import { Box, Card, CardContent } from '@mui/material';
import { InputList, type InputListTemplateProps } from 'framework/form';
import type { FillInputProps } from '../fillInput';
import { keptRows, numberOf } from '../shared/bounds';

export const RepeatableGroupInput = (props: FillInputProps<object[], object>) => {
  const { rows, inputId, labelId, describedBy, value, onChange, disabled, required, bounds } = props;
  if (!rows) return null;
  const max = numberOf(bounds.max) ?? Infinity;

  return (
    <Box role="group" aria-labelledby={labelId} aria-describedby={describedBy}>
      <InputList
        source={inputId}
        label=""
        value={value}
        onChangeCallback={data => onChange(data[inputId])}
        defaultValue={{}}
        disabled={disabled}
        minFields={keptRows(required, bounds)}
        maxFields={max}
        isAddable={value.length < max}
        inputTemplate={RepeatableGroupRow}
        inputProps={{ renderRow: rows.render }}
        addText="Add another"
        rowSx={{ alignItems: 'flex-start', '& > .MuiCard-root': { flex: 1, minWidth: 0 } }}
      />
    </Box>
  );
};

const RepeatableGroupRow = ({ index, renderRow }: InputListTemplateProps) => {
  return (
    <Card>
      <CardContent>{renderRow(index)}</CardContent>
    </Card>
  );
};
